export default __webpack_public_path__ + "static/media/Thaumaturge's Bracers of Regal Might.74671900.jpg";